import React, { memo } from "react";
import { Image, View } from "react-native";
import { useScreenDimensions, useDevice } from "../_layout";
import { observer } from "mobx-react";

const LogoImage = observer(({ coach }) => {
  const { screenSize } = useScreenDimensions();
  // Calculate the height and width based on screen size and aspect ratio
  const adjustedHeight = screenSize === "small" ? 30 : 50;
  const adjustedWidth = adjustedHeight / coach.logoAspectRatioHW;
  // console.log("LogoImage Refreshed");
  // Render the image only if coach.logoUrl exists
  return (
    coach.logoUrl && (
      <Image
        source={{ uri: coach.logoUrl }}
        style={{
          width: adjustedWidth,
          height: adjustedHeight,
          borderRadius: 8,
        }}
        //  testID="maskedLogo"
        // nativeID="maskedLogo"
        // dataSet={{ sensitive: "true" }}
      />
    )
  );
});

// Use React.memo to prevent unnecessary re-renders when props don't change
export default memo(LogoImage);
